import { PubsubTopic } from "@megaron/pubsub-contracts";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

import { interactionMentionSerializer } from "./history";
import { ordersChangedTopic } from "./orders";

export const customerDocsChangedTopic = PubsubTopic({
  name: "crm-customer-docs-changed",
  serializer: Serializers.object({
    unmodifiedSince: Serializers.datetime,
  }),
});

export type CustomerDocsChangedMessage = SerializerValue<typeof customerDocsChangedTopic.serializer>;

export const interactionDocsChangedTopic = PubsubTopic({
  name: "crm-interaction-docs-changed",
  serializer: Serializers.object({
    unmodifiedSince: Serializers.datetime,
  }),
});

export type InteracitonDocsChangedMessage = SerializerValue<typeof interactionDocsChangedTopic.serializer>;

export const loyaltyCustomerAddedTopic = PubsubTopic({
  name: "crm-loyalty-customer-added",
  serializer: Serializers.object({
    accountUuid: uuidSerializer,
  }),
});

export type LoyaltyCustomerAddedMessage = SerializerValue<typeof loyaltyCustomerAddedTopic.serializer>;

export const customerChangeTypes = [
  "added",
  "updated",
  "regionChanged",
  "tagsChanged",
  "purchaseFunnelChanged",
  "statusChanged",
  "interactionSaved",
  "purchaseAdded",
  "relationAdded",
  "relationRemoved",
] as const;

export const customerChangedTopic = PubsubTopic({
  name: "crm-customer-changed",
  serializer: Serializers.object({
    customerUuid: uuidSerializer,
    changeType: Serializers.stringOneOf<(typeof customerChangeTypes)[number]>(...customerChangeTypes),
  }),
});

export type CustomerChangedMessage = SerializerValue<typeof customerChangedTopic.serializer>;

export const regionChangedTopic = PubsubTopic({
  name: "crm-region-changed",
  serializer: Serializers.object({
    regionName: Serializers.string,
    newOwnerEmail: Serializers.string.nullable(),
  }),
});

export type RegionChangedMessage = SerializerValue<typeof regionChangedTopic.serializer>;

export const interactionSavedTopic = PubsubTopic({
  name: "crm-interaction-posted",
  serializer: Serializers.object({
    customerId: uuidSerializer,
    interactionId: uuidSerializer,
    postedBy: Serializers.string,
    message: Serializers.string,
    mentions: interactionMentionSerializer.array(),
  }),
});

export type InteractionSavedMessage = SerializerValue<typeof interactionSavedTopic.serializer>;

export const crmTopics = [
  customerDocsChangedTopic,
  interactionDocsChangedTopic,
  loyaltyCustomerAddedTopic,
  customerChangedTopic,
  regionChangedTopic,
  interactionSavedTopic,
  ordersChangedTopic,
];
